import Alpine from 'https://cdn.jsdelivr.net/npm/alpinejs@3.14.3/+esm' 
        
Alpine.store('backer', {
    set_backer_code: function(backer_code) {
        const url = new URL( window.location.href );
        
        let params = url.searchParams;
        params.set( 'code', backer_code);
        if(params !== '') {
            params = "?" + params;
        }
        let new_url = url.origin + url.pathname + params;
        if(new_url !== window.location.href) {
            window.history.pushState('', '', new_url);
        }                

        window.localStorage.setItem( 'jb-pm-url', new_url);
    },
    set_campaign_name: function(campaign_name) {
        window.localStorage.setItem( 'jb-pm-campaign-name', campaign_name);
    },
    get_cart_trimmed: function() {
        let cart = JSON.parse(JSON.stringify(this.cart));
        let trimmed_cart = {};
        // Trim off anything that's not variant_id or quantity
        // filter out items where quantity is 0
        let items = [];
        cart.items.forEach(item => {
            if(item.quantity > 0) {
                items.push({ variant_id: item.variant_id, quantity: item.quantity });
            }
        });
        trimmed_cart.items = items;

        // filter out product choices selections where quantity is 0
        if(cart.product_choices) {
            let product_choices = {};
            for (const product_collection_id in cart.product_choices) {
                if (cart.product_choices.hasOwnProperty(product_collection_id)) {
                    
                    if(cart.product_choices[product_collection_id].selections.some(s => s.quantity > 0)) {
                        let selections = [];
                        cart.product_choices[product_collection_id].selections.forEach(s => {
                            if(s.quantity > 0) {
                                selections.push({ variant_id: s.variant_id, quantity: s.quantity });
                            }
                        });
                        product_choices[product_collection_id] = { product_collection_id: product_collection_id, selections: selections };
                    }
                }
            }
            trimmed_cart.product_choices = product_choices;
        }
        return trimmed_cart;
    },
    item_quantity: function(variant_id) {        
        let variant_ids = null;
        if(Array.isArray(variant_id)) {
            variant_ids = variant_id;
        } else {
            variant_id = parseInt(variant_id);
            variant_ids = [variant_id];
        }
        let quantity = this.cart.items.reduce((acc, item) => variant_ids.find(id => id === item.variant_id) ? acc + item.quantity : acc, 0);        
        let choice_quantity = 0;
        if(this.cart.product_choices) {
            for (const product_collection_id in this.cart.product_choices) {
                if (this.cart.product_choices.hasOwnProperty(product_collection_id)) {
                    let selections = this.cart.product_choices[product_collection_id].selections;
                    for (const selection of selections) {
                        if(variant_ids.find(id => id === selection.variant_id)) {
                            choice_quantity += selection.quantity;
                        }
                    }
                }
            }
        }

        return quantity + choice_quantity;
    },
    add_item: function(variant_id) {
        variant_id = parseInt(variant_id);                    
        let item = this.cart.items.find(i => i.variant_id === variant_id);
        if(item) {
            item.quantity = (item.quantity ?? 0) + 1;
        } else {
            this.cart.items.push({ variant_id: variant_id, quantity: 1 });
        }
    },
    remove_item: function(variant_id) {
        variant_id = parseInt(variant_id);
        let item = this.cart.items.find(i => i.variant_id === variant_id);
        if(item) {
            item.quantity--;
            if(item.quantity <= 0) {
                this.cart.items = this.cart.items.filter(i => i.variant_id !== variant_id);
            }
        }
    },
    set_item_quantity: function(variant_id, quantity) {
        variant_id = parseInt(variant_id);
        let item = this.cart.items.find(i => i.variant_id === variant_id);
        if(item) {
            item.quantity = quantity;
        } else {
            this.cart.items.push({ variant_id: variant_id, quantity: quantity });
        }
    },

    product_choice_total: function(product_collection_id) {
        if(!this.cart.product_choices) {
            return 0;
        }
        if(!(product_collection_id in this.cart.product_choices)) {
            return 0;
        }
        let selections = this.cart.product_choices[product_collection_id].selections;

        // add together the values at each key in choice
        let total_quantity = 0;
        for (const variant_id in selections) {
            if (selections.hasOwnProperty(variant_id)) {
                total_quantity += selections[variant_id].quantity;
            }
        }        
        return total_quantity;                    
    },                
    init_product_choice: function(product_collection_id, variant_id) {
        if(!this.cart.product_choices) {
            this.cart.product_choices = {};
        }
        if(!(product_collection_id in this.cart.product_choices)) {
            this.cart.product_choices[product_collection_id] = { product_collection_id: product_collection_id, selections: [] };
        }
        this.cart.product_choices[product_collection_id].selections = this.cart.product_choices[product_collection_id].selections || [];
        
        let selection = this.cart.product_choices[product_collection_id].selections.find(s => s.variant_id === variant_id);
        if(!selection) {
            selection = { variant_id: variant_id, quantity: 0 };
            this.cart.product_choices[product_collection_id].selections.push(selection)
        }
        return selection;                    
    },
    set_product_choice: function(product_collection_id, variant_id) {
        let selection = this.init_product_choice(product_collection_id, variant_id);                         
        this.cart.product_choices[product_collection_id].selections.forEach(s => s.quantity = s.variant_id == variant_id ? 1 : 0);
        return selection;
    },
});

Alpine.start();